import { createRoute } from '@tanstack/react-router';
import { Footer } from 'components/Footer';
import { Header } from 'components/Header';
import { JoinWaitlistSection } from 'components/sections/JoinWaitlistSection';
import { RouterKey } from 'consts';
import { useEffect } from 'react';
import { rootRoute } from 'router';

export const RegisterNow = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-[100vh] flex flex-col justify-between">
      <main className="pt-20 h-full">
        <Header />
        <JoinWaitlistSection />
      </main>
      <Footer />
    </div>
  );
};

export const registerNowPageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: RouterKey.REGISTER_NOW,
  component: RegisterNow,
});
